import * as yup from 'yup';
import FormFieldType from 'src/shared/ui/components/Form/FormFieldFactory/FormFieldType';
import { t } from 'src/shared/literals';

const CustomerContact = ({ fields, contractTypeList, paymentTypeList }) => [
  {
    name: 'document',
    validation: yup
      .string()
      .trim()
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.document ? fields.document : '',
    readonly: fields && fields.id
  },
  {
    name: 'relationship',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.SELECT,
    value: fields && fields.relationship ? fields.relationship : '',
    options: [
      'HOLDER',
      'COMPANY',
      'FAMILY',
      'FRIEND',
      'WIFE',
      'SON',
      'BROTHER',
      'GRANDMOTHER',
      'GRANDFATHER',
      'EMPLOYEE',
      'OTHER'
    ].map((x) => {
      return { id: x, name: x };
    })
    //readonly: fields && fields.id
  },
  {
    name: 'firstname',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.firstname ? fields.firstname : '',
    //readonly: fields && fields.id,
    fullWidth: true
  },
  {
    name: 'surnames',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.surnames ? fields.surnames : '',
    //readonly: fields && fields.id,
    fullWidth: true
  },
  {
    name: 'email',
    validation: yup
      .string()
      .trim()
      .nullable(true),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.email ? fields.email : '',
    //readonly: fields && fields.id,
    fullWidth: true
  },
  {
    name: 'address',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.address ? fields.address : '',
    fullWidth: true
  },
  {
    name: 'department',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.department ? fields.department : ''
  },
  {
    name: 'city',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.city ? fields.city : ''
  },
  {
    name: 'neighborhood',
    validation: yup.string().nullable(true),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.neighborhood ? fields.neighborhood : ''
  },
  {
    name: 'zoneCode',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.zoneCode ? fields.zoneCode : ''
  },
  {
    name: 'latitude',
    validation: yup
      .number()
      .nullable(true)
      .transform((curr, orig) => (orig === '' ? null : curr)),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.latitude ? fields.latitude : ''
  },
  {
    name: 'longitude',
    validation: yup
      .number()
      .nullable(true)
      .transform((curr, orig) => (orig === '' ? null : curr)),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.longitude ? fields.longitude : ''
  },
  {
    name: 'birthdate',
    validation: yup.date(),
    type: FormFieldType.DATE,
    value: fields && fields.birthdate ? fields.birthdate : '1970-01-01'
  },
  {
    name: 'phone1',
    validation: yup
      .string()
      .trim()
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.phone1 ? fields.phone1 : ''
  },
  {
    name: 'phone2',
    validation: yup
      .string()
      .trim()
      .nullable(true),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.phone2 ? fields.phone2 : ''
  },
  {
    name: 'paymentTypeListId',
    validation: yup
      .array()
      .of(yup.string())
      .nullable(true),
    type: FormFieldType.SELECT_CHIP,
    value: fields && fields.paymentTypeListId ? fields.paymentTypeListId : [],
    options: paymentTypeList.map((x) => {
      return { id: x.id, name: t(x.code.toLowerCase()) };
    })
  },
  {
    name: 'preferredPaymentDay',
    validation: yup
      .number()
      .typeError('fieldNumeric')
      .nullable(true),
    type: FormFieldType.TEXT_FIELD,
    value:
      fields && fields.preferredPaymentDay ? fields.preferredPaymentDay : null
  },
  {
    name: 'additionalServiceContractTypeListId',
    validation: yup
      .array()
      .of(yup.string())
      .nullable(true),
    type: FormFieldType.SELECT_CHIP,
    value:
      fields && fields.additionalServiceContractTypeListId
        ? fields.additionalServiceContractTypeListId
        : [],
    options: contractTypeList.filter((x) => x.nextBillPeriod)
  },
  {
    name: 'hasUser',
    validation: yup.boolean(),
    type: FormFieldType.CHECKBOX,
    value: fields && fields.hasUser != null ? fields.hasUser : false
  },
  {
    name: 'sendInvoiceEmail',
    validation: yup.boolean(),
    type: FormFieldType.CHECKBOX,
    value:
      fields && fields.sendInvoiceEmail != null
        ? fields.sendInvoiceEmail
        : false
  },
  {
    name: 'comments',
    validation: yup.string().nullable(true),
    type: FormFieldType.TEXT_AREA,
    value: fields && fields.comments ? fields.comments : '',
    fullWidth: true,
    readonly: true
  },
  {
    name: 'newComment',
    validation: yup.string().nullable(true),
    type: FormFieldType.TEXT_AREA,
    value: fields && fields.newComment ? fields.newComment : '',
    fullWidth: true
  }
];

export default CustomerContact;
